/**
 * @generated SignedSource<<af1dd70ba57465d1d17ed4ca36986564>>
 * @relayHash e662580b7d3bc4d039c91a4ee4d0d0b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea79be941458fcf66e00d12b05069a7647017b6fb389c5226b26eca173f27d46

import type { ConcreteRequest } from 'relay-runtime';
export type AccessStatus = "ANONYMOUS_ACCESS" | "EXTERNAL_COLLABORATOR_ACCESS" | "EXTERNAL_SHARE_ACCESS" | "LICENSED_ADMIN_ACCESS" | "LICENSED_USE_ACCESS" | "NOT_PERMITTED" | "UNLICENSED_AUTHENTICATED_ACCESS" | "%future added value";
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type Environment = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type SiteInformationQuery$variables = Record<PropertyKey, never>;
export type SiteInformationQuery$data = {
  readonly abTestCohorts: string | null;
  readonly confluence_tenantContext: {
    readonly baseUrl: string;
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
    readonly licenseStates: {
      readonly confluence: {
        readonly ccpEntitlementId: string | null;
      } | null;
    } | null;
    readonly monolithRegion: string | null;
    readonly timeZone: string | null;
  } | null;
  readonly currentConfluenceUser: {
    readonly isAnonymous: boolean;
  } | null;
  readonly experimentFeatures: string | null;
  readonly getAIConfig: {
    readonly isAIEarlyAccessEnabled: boolean | null;
    readonly isAtlassianHostedLLMOnlyEnabled: boolean | null;
    readonly isEnabled: boolean;
    readonly isRovoEnabled: boolean | null;
    readonly isRovoLLMEnabled: boolean | null;
  } | null;
  readonly isNewUser: boolean | null;
  readonly isSiteAdmin: boolean | null;
  readonly organization: {
    readonly orgId: string | null;
  } | null;
  readonly siteDescription: {
    readonly logoUrl: string | null;
  } | null;
  readonly siteSettings: {
    readonly companyHubName: string | null;
    readonly frontCover: {
      readonly frontCoverState: string | null;
    } | null;
    readonly homepage: {
      readonly title: string | null;
      readonly uri: string | null;
    } | null;
    readonly isBylineShowAllByDefault: boolean;
    readonly isHideTitleInUrl: boolean;
    readonly showApplicationTitle: boolean;
    readonly siteTitle: string;
  } | null;
  readonly tenant: {
    readonly activationId: string | null;
    readonly cloudId: string;
    readonly environment: Environment;
    readonly shard: string;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly accessStatus: AccessStatus;
      readonly accountId: string | null;
      readonly locale: string;
      readonly userKey: string | null;
    } | null;
    readonly displayName: string | null;
    readonly id: string | null;
    readonly timeZone: string | null;
  } | null;
  readonly userCanCreateContent: boolean | null;
  readonly userForAnalytics: {
    readonly id: string | null;
  } | null;
};
export type SiteInformationQuery = {
  response: SiteInformationQuery$data;
  variables: SiteInformationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "timeZone"
},
v2 = [
  {
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenant",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "shard"
      },
      {
        "kind": "ScalarField",
        "name": "cloudId"
      },
      {
        "kind": "ScalarField",
        "name": "environment"
      },
      {
        "kind": "ScalarField",
        "name": "activationId"
      }
    ]
  },
  {
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "orgId"
      }
    ]
  },
  {
    "alias": "userForAnalytics",
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accessStatus"
          },
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "userKey"
          },
          {
            "kind": "ScalarField",
            "name": "locale"
          }
        ]
      },
      (v1/*: any*/)
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "product",
        "value": "CONFLUENCE"
      }
    ],
    "concreteType": "AIConfigResponse",
    "kind": "LinkedField",
    "name": "getAIConfig",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isRovoEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isAIEarlyAccessEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isAtlassianHostedLLMOnlyEnabled"
      },
      {
        "kind": "ScalarField",
        "name": "isRovoLLMEnabled"
      }
    ],
    "storageKey": "getAIConfig(product:\"CONFLUENCE\")"
  },
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "baseUrl"
      },
      {
        "concreteType": "LicenseStates",
        "kind": "LinkedField",
        "name": "licenseStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "LicenseState",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }
            ]
          }
        ]
      },
      (v1/*: any*/),
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "monolithRegion"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "abTestCohorts"
  },
  {
    "kind": "ScalarField",
    "name": "experimentFeatures"
  },
  {
    "kind": "ScalarField",
    "name": "userCanCreateContent"
  },
  {
    "kind": "ScalarField",
    "name": "isNewUser"
  },
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "Homepage",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "uri"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "siteTitle"
      },
      {
        "kind": "ScalarField",
        "name": "showApplicationTitle"
      },
      {
        "concreteType": "FrontCover",
        "kind": "LinkedField",
        "name": "frontCover",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "frontCoverState"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "companyHubName"
      },
      {
        "kind": "ScalarField",
        "name": "isHideTitleInUrl"
      },
      {
        "kind": "ScalarField",
        "name": "isBylineShowAllByDefault"
      }
    ]
  },
  {
    "concreteType": "SiteDescription",
    "kind": "LinkedField",
    "name": "siteDescription",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "logoUrl"
      }
    ]
  },
  {
    "concreteType": "CurrentConfluenceUser",
    "kind": "LinkedField",
    "name": "currentConfluenceUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isAnonymous"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SiteInformationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SiteInformationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e662580b7d3bc4d039c91a4ee4d0d0b5",
    "id": "ea79be941458fcf66e00d12b05069a7647017b6fb389c5226b26eca173f27d46",
    "metadata": {},
    "name": "SiteInformationQuery",
    "operationKind": "query",
    "text": "query SiteInformationQuery{tenant{shard,cloudId,environment,activationId},organization{orgId},userForAnalytics:confluence_atlassianUser{id},user:confluence_atlassianUser(current:true){id,displayName,confluence{accessStatus,accountId,userKey,locale},timeZone},getAIConfig(product:CONFLUENCE){isEnabled,isRovoEnabled,isAIEarlyAccessEnabled,isAtlassianHostedLLMOnlyEnabled,isRovoLLMEnabled},confluence_tenantContext{baseUrl,licenseStates{confluence{ccpEntitlementId}},timeZone,editions{confluence},monolithRegion},isSiteAdmin,abTestCohorts,experimentFeatures,userCanCreateContent,isNewUser,siteSettings{homepage{uri,title},siteTitle,showApplicationTitle,frontCover{frontCoverState},companyHubName,isHideTitleInUrl,isBylineShowAllByDefault},siteDescription{logoUrl},currentConfluenceUser{isAnonymous}}"
  }
};
})();

(node as any).hash = "7debe9289cb1db6fc5febfba7acfa1a0";

export default node;
